<template>
  <section class="cs-sign-in">
    <loader ref="loader" />
    <div class="d-flex">
      <div class="cs-sign-in__title-wrapper">
        <h1 class="cs-sign-in__title">
          {{ $t("sign-in.welcome") }}
        </h1>
        <div class="cs-sign-in__subtitle">
          {{ $t("sign-in.sign-in-with-rocketfuel", { partner: title }) }}
        </div>
      </div>
    </div>
    <div v-if="magicActive">
      <MagicLink @offMagic="offMagicLink" />
    </div>
    <div v-if="!magicActive">
      <Form @submit="signIn">
        <div class="cs-sign-in__inputs-box">
          <text-input
            id="email"
            name="email"
            v-model:value.trim="email"
            :placeholder="$t('sign-in.email')"
            ref="email"
            :schema="emailSchema"
            autocomplete="email"
          />

          <text-input
            id="password"
            v-model:value.trim="password"
            name="password"
            :schema="passwordSchema"
            :type="!displayPassword ? 'password' : 'text'"
            :placeholder="$t('sign-in.password')"
            :imgSource="
              !displayPassword
                ? require('@/assets/img/eye-slash.svg')
                : require('@/assets/img/eye.svg')
            "
            @handle-input-icon="toggleDisplayPassword"
          />
        </div>
        <small class="cs-sign-in__error" v-if="error">
          {{ error }}
        </small>
        <CustomButton
          className="cs-sign-in__btn w-100 button-default mt-4 p-12"
          type="submit"
          :name="$t('sign-in.sign-in')"
        />
      </Form>
      <div class="cs-sign-in__link-box">
        <a
          target="_blank"
          :href="resetUrl"
          class="cs-sign-in__link"
          @click.prevent="onForgetPassword"
        >
          {{ $t("sign-in.forgot-password") }}
        </a>
      </div>
      <div class="sign-up-text">
        {{ changePartnerLabelName(marketInfo, "sign-in.no-account") }}
        <span @click="doSignUp()" class="sign-up-btn cursor-pointer">
          {{ $t("sign-in.sign-up") }}
        </span>
      </div>
    </div>
    <!-- eslint-disable-next-line-->
    <component is="style" scoped>
      :root { --button-default-background-color:{{
        defaultButtonBackgroundColor
      }}; --button-default-text-color:{{ defaultButtonTextColor }};
      --button-default-hover-background-color:{{
        defaultButtonHoverBackgroundColor
      }}; --button-default-hover-text-color:{{ defaultButtonHoverTextColor }};
      --button-default-outline-background-color:{{
        defaultOutlineButtonBackgroundColor
      }}; --button-default-outline-text-color:{{
        defaultOutlineButtonTextColor
      }}; }
    </component>
  </section>
</template>

<script>
import { mapGetters } from "vuex";
import MagicLink from "@/components/magicLink.vue";
import {
  // SIGN_IN,
  SIGN_IN_HASHED,
} from "@/store/modules/auth/consts";

import {
  GET_USER_INFO,
  SET_TAB,
  USER_TRACK_EVENTS,
} from "@/store/modules/user/consts";
import CustomButton from "./customButton.vue";
import * as Yup from "yup";
export default {
  components: {
    CustomButton,
    MagicLink,
  },
  data() {
    return {
      popup: null,
      email: this.$store.getters["auth/userEmail"] || "",
      password: "",
      error: "",
      termsConditions: false,
      signInUrl:
        process.env.VUE_APP_SIGNUP_URL ||
        "https://app.rocketfuelblockchain.com/choose-role",
      resetUrl:
        process.env.VUE_APP_RESET_URL ||
        "https://app.rocketfuelblockchain.com/reset",
      displayPassword: false,
      magicActive: true,
    };
  },
  setup() {
    const emailSchema = Yup.string().email("Invalid email").required("Please enter you email");
    const passwordSchema = Yup.string().required("Please enter your password");
    return { emailSchema, passwordSchema };
  },
  computed: {
    ...mapGetters({
      marketInfo: "user/marketInfo",
      cart: "user/cart",
      tab: "user/tab",
    }),
    title() {
      if (
        this.marketInfo &&
        this.marketInfo.whiteLabel &&
        this.marketInfo.whiteLabel.colorSchema &&
        this.marketInfo.whiteLabel.colorSchema.partnerLabel
      ) {
        return this.marketInfo.whiteLabel.colorSchema.partnerLabel;
      }
      return "Rocketfuel";
    },
    defaultButtonBackgroundColor() {
      if (
        this.marketInfo &&
        this.marketInfo.whiteLabel &&
        this.marketInfo.whiteLabel.colorSchema &&
        this.marketInfo.whiteLabel.colorSchema.colors &&
        this.marketInfo.whiteLabel.colorSchema.colors.some(
          (el) => el.name === "Button"
        )
      ) {
        const section = this.marketInfo.whiteLabel.colorSchema.colors.find(
          (el) => el.name === "Button"
        );
        const child = section.children.find((el) => el.name === "Default");
        const property = child.properties.find(
          (el) => el.name === "Background Color"
        );
        if (property && Object.keys(property).length) {
          return property.value;
        }
      }
      return "#f0833c";
    },
    defaultButtonTextColor() {
      if (
        this.marketInfo &&
        this.marketInfo.whiteLabel &&
        this.marketInfo.whiteLabel.colorSchema &&
        this.marketInfo.whiteLabel.colorSchema.colors &&
        this.marketInfo.whiteLabel.colorSchema.colors.some(
          (el) => el.name === "Button"
        )
      ) {
        const section = this.marketInfo.whiteLabel.colorSchema.colors.find(
          (el) => el.name === "Button"
        );
        const child = section.children.find((el) => el.name === "Default");
        const property = child.properties.find(
          (el) => el.name === "Text Color"
        );
        if (property && Object.keys(property).length) {
          return property.value;
        }
      }
      return "#ffffff";
    },
    defaultButtonHoverBackgroundColor() {
      if (
        this.marketInfo &&
        this.marketInfo.whiteLabel &&
        this.marketInfo.whiteLabel.colorSchema &&
        this.marketInfo.whiteLabel.colorSchema.colors &&
        this.marketInfo.whiteLabel.colorSchema.colors.some(
          (el) => el.name === "Button"
        )
      ) {
        const section = this.marketInfo.whiteLabel.colorSchema.colors.find(
          (el) => el.name === "Button"
        );
        const child = section.children.find((el) => el.name === "Default");
        const property = child.properties.find(
          (el) => el.name === "Background Color on hover"
        );
        if (property && Object.keys(property).length) {
          return property.value;
        }
      }
      return "#0d102a";
    },
    defaultButtonHoverTextColor() {
      if (
        this.marketInfo &&
        this.marketInfo.whiteLabel &&
        this.marketInfo.whiteLabel.colorSchema &&
        this.marketInfo.whiteLabel.colorSchema.colors &&
        this.marketInfo.whiteLabel.colorSchema.colors.some(
          (el) => el.name === "Button"
        )
      ) {
        const section = this.marketInfo.whiteLabel.colorSchema.colors.find(
          (el) => el.name === "Button"
        );
        const child = section.children.find((el) => el.name === "Default");
        const property = child.properties.find(
          (el) => el.name === "Text Color On hover"
        );
        if (property && Object.keys(property).length) {
          return property.value;
        }
      }
      return "#ffffff";
    },
    defaultOutlineButtonBackgroundColor() {
      if (
        this.marketInfo &&
        this.marketInfo.whiteLabel &&
        this.marketInfo.whiteLabel.colorSchema &&
        this.marketInfo.whiteLabel.colorSchema.colors &&
        this.marketInfo.whiteLabel.colorSchema.colors.some(
          (el) => el.name === "Button"
        )
      ) {
        const section = this.marketInfo.whiteLabel.colorSchema.colors.find(
          (el) => el.name === "Button"
        );
        const child = section.children.find((el) => el.name === "Outline");
        const property = child.properties.find(
          (el) => el.name === "Background Color"
        );
        if (property && Object.keys(property).length) {
          return property.value;
        }
      }
      return "#ffffff";
    },
    defaultOutlineButtonTextColor() {
      if (
        this.marketInfo &&
        this.marketInfo.whiteLabel &&
        this.marketInfo.whiteLabel.colorSchema &&
        this.marketInfo.whiteLabel.colorSchema.colors &&
        this.marketInfo.whiteLabel.colorSchema.colors.some(
          (el) => el.name === "Button"
        )
      ) {
        const section = this.marketInfo.whiteLabel.colorSchema.colors.find(
          (el) => el.name === "Button"
        );
        const child = section.children.find((el) => el.name === "Outline");
        const property = child.properties.find(
          (el) => el.name === "Text Color"
        );
        if (property && Object.keys(property).length) {
          return property.value;
        }
      }
      return "#5e72e4";
    },
  },
  mounted() {
    this.$store.dispatch(`user/${SET_TAB}`, "");
    this.$refs.loader.hide();
    setTimeout(() => {
      // this.$refs.email.$el.focus();
    }, 500);
  },
  methods: {
    offMagicLink() {
      this.magicActive = false;
      this.email = this.$store.getters["auth/userEmail"];
    },
    handleEnterClick() {
      this.signIn();
    },
    async signIn() {
      if (this.$DbStorage.getItem("rocketfuel_connect")) {
        this.$DbStorage.removeItem("rocketfuel_connect");
        switch (this.$DbStorage.getItem("rocketfuel_connect")) {
          case "coinbase":
            // this.popup = window.open(
            //   "",
            //   "exchange_connect10",
            //   `width=585, height=800, top=${
            //     (window.screen.height - 800) / 2
            //   }, left=${(window.screen.width - 585) / 2}, _blank`
            // );
            break;
          case "binance":
            break;
          case "gemini":
            break;
          case "kraken":
            break;
          case "bank":
            break;
          default:
            break;
        }
      }

      this.$nextTick(async () => {
        this.$refs.loader.start();
        let merchantId = null;
        if (this.cart && this.cart.merchant_id) {
          merchantId = btoa(this.cart.merchant_id);
        }
        const encryptedReq = this.encryptStringWithRSA(
          JSON.stringify({
            merchantId,
            email: this.email.toLowerCase(),
            password: this.password,
          })
        );
        try {
          await this.$store.dispatch(`auth/${SIGN_IN_HASHED}`, {
            encryptedReq,
          });
          const info = await this.$store.dispatch(`user/${GET_USER_INFO}`);
          if (info.type === 1) {
            if (this.popup) {
              this.popup.focus();
              this.popup.close();
              this.popup = null;
            }
            this.$store.commit("auth/logOut");
            throw new Error("This email is used by merchant");
          }
          if (this.$store.getters["auth/userStatus"] !== 1) {
            if (this.popup) {
              this.popup.focus();
              this.popup.close();
              this.popup = null;
            }
            this.$store.commit("auth/logOut");
            throw new Error("Please, confirm your email");
          }
          if (!Object.values(this.$store.getters["user/cart"]).length) {
            this.notifyParentWindow({
              type: "rocketfuel_get_cart",
            });
          }
          this.$store.dispatch(`user/${USER_TRACK_EVENTS}`, {
            moduleInfo: {
              current: "Login",
              activity: "signin with password button clicked",
            },
          });
          this.$router.push({ name: "Payment" });
        } catch (e) {
          if (this.popup) {
            this.popup.focus();
            this.popup.close();
            this.popup = null;
          }
          if (e.response) {
            if (e.response.data.message === "Invalid OTP") {
              this.$store.dispatch(`user/${USER_TRACK_EVENTS}`, {
                moduleInfo: {
                  current: "Login",
                  activity: "signin with password button clicked",
                },
              });
              this.$router.push({
                name: "Totp",
                params: {
                  data: this.Encrypt(JSON.stringify({
                    email: this.email.toLowerCase(),
                    password: this.password,
                  })),
                },
              });
            } else {
              this.error = e.response.data.message;
            }
          } else {
            this.error = e.message;
          }
          this.$refs.loader.end();
        }
      });
    },
    doSignUp() {
      this.$router.push({
        name: "SignUp",
      });
    },
    onForgetPassword() {
      this.$router.push({
        name: "ForgetPassword",
      });
    },
    toggleDisplayPassword() {
      this.displayPassword = !this.displayPassword;
    },
    selectLang(event) {
      this.selectedValue = event.target.innerText;
      this.$i18n.locale = this.selectedValue;
      this.$DbStorage.setItem("lang", this.selectedValue);
    },
  },
};
</script>

<style lang="scss">
.cs-sign-in {
  position: relative;
  width: 100%;
  padding: 40px 20px 20px;
  &__error {
    width: 100%;
    color: $red500;
    margin-bottom: 9px;
    margin-top: 15px;
    font-size: 16px;
    line-height: 1;
    min-height: 16px;
  }
  &__title-wrapper {
    width: 70%;
  }
  &__title {
    margin-top: 20px;
    font-weight: 700;
    font-size: 24px;
    line-height: 1;
    margin-bottom: 5px;
  }
  .lang-dd {
    margin-top: 25px;
  }

  &__subtitle {
    font-weight: 500;
    font-size: 16px;
    line-height: 22px;
    margin-bottom: 25px;
    color: #515469;
  }

  &__inputs-box {
    display: grid;
    gap: 10px;
    // margin-bottom: 10px;
  }

  &__link-box {
    text-align: center;
    margin-top: 15px;
    margin-bottom: 13px;
  }

  &__link {
    font-size: 14px;
    line-height: 27px;
    color: #5559fe;
    &:hover {
      text-decoration: none;
    }
  }

  &__hr-box {
    display: flex;
    align-items: center;
    margin: 7px 0;
  }

  &__hr {
    width: 100%;
    height: 1px;
    background-color: $black300;
  }

  &__or {
    width: 40px;
    min-width: 40px;
    height: 28px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 300;
    font-size: 14px;
    line-height: 1;
    color: $black400;
  }
  &__btn {
    margin-bottom: 10px;
    text-decoration: none;
  }
  .sign-up-text {
    margin-top: 80px;
    text-align: center;
    font-size: 14px;
    color: #6e728b;
    left: 10%;
    .sign-up-btn {
      color: var(--button-default-background-color);
      font-size: 16px;
      font-weight: 500;
      &:hover {
        text-decoration: underline;
      }
    }
  }
  .terms-conditions {
    input {
      vertical-align: middle;
      margin-right: 5px;
    }
    span {
      font-size: 12px;
      color: #898ca1;
      .text-orange {
        color: #f0833c;
        font-weight: 500;
      }
    }
  }
}

.session-expiry-img {
  display: block;
  margin: auto;
}
</style>
